import React from "react"
import PropTypes from "prop-types"
import Footer from "./Footer"
import "typeface-exo"
import "./layout.scss"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import RequestQuoteCTA from "../components/RequestQuoteCTA"

const Layout = ({ children, location }) => {
  return (
    <div>
      <main id="mainBody">{children}</main>
      <Footer />
      <RequestQuoteCTA location={location} />
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
